import { FC } from 'react';
import { LoadingOutlined } from '@ant-design/icons';

import './Loader.scss';

export interface Props {
  variant: 'small' | 'big';
}

const Loader: FC<Props> = props => {
  switch (props.variant) {
    case 'small':
      return (
        <LoadingOutlined
        // style={{ color: 'red' }}
        />
      );
    case 'big':
      return (
        <div id="loader-wrapper">
          <div id="loader"></div>
        </div>
      );
  }
};

export { Loader };
